import React from "react";

// Compact roofline motif for captions and process markers. Decorative only.
type RooflineMarkProps = {
  className?: string;
};
export function RooflineMark({
  className = ""
}: RooflineMarkProps) {
  return <svg aria-hidden="true" width="28" height="12" viewBox="0 0 28 12" fill="none" className={className} data-id="element-584" data-mp="28slswtxqcgkc">
      <path d="M0 11.5 L9 4 L13 7.5 L18 1 L28 11.5" stroke="currentColor" strokeWidth="1.5" data-id="element-585" data-mp="2drowe9y2aeq7" />
    </svg>;
}